/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const paginatedUsersDataSchema = z.object({
	data: z.array(
		z.object({
			userId: z.string(),
			role: z.union([z.literal('member'), z.literal('admin'), z.literal('jobillan'), z.literal('recruiter')]),
			avatarUrl: z.string().nullable(),
			name: z.string().nullable(),
			email: z.string().nullable(),
			joinedAt: z.iso.datetime(),
			permissions: z.array(z.string()).nullable().default([]),
		}),
	),
	meta: z.object({ total: z.number(), limit: z.number(), offset: z.number() }),
})

export type PaginatedUsersDataSchema = z.infer<typeof paginatedUsersDataSchema>
